import { render, staticRenderFns } from "./commsso.vue?vue&type=template&id=b8b3aaf0&scoped=true&"
import script from "./commsso.vue?vue&type=script&lang=js&"
export * from "./commsso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b3aaf0",
  null
  
)

export default component.exports